import { render } from "./WaitListForm.vue?vue&type=template&id=650d703c&ts=true"
import script from "./WaitListForm.vue?vue&type=script&lang=ts"
export * from "./WaitListForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__